import React, { useState } from 'react';
import { Group } from '../../../../redux/groups/api/group.model';
import { useUserRightUtil } from '../../../../util/rights';
import { getPolyglot } from '../../../../i18n';
import { IconButton } from '@mui/material';
import { AddIcon } from '../../../../theme/icons';
import { MenuItemPrimary, MenuPrimary } from '../../../../theme/components';
import AddStoreModal from './AddStoreModal/AddStoreModal';

interface AddButtonDeviceManagerProps {
  groupId?: string;
  group?: Group;
}
/**
 * Button menu to add
 * stores
 */
function AddButtonStoreManager(props: AddButtonDeviceManagerProps) {
  const { groupId, group } = props;
  const polyglot = getPolyglot();
  let showButtonAddGroup = false;
  const rightsUserUtil = useUserRightUtil();
  if (!groupId) {
    /* If the user are in the high group level we should check in the masterScope if
    the user has the right Authorized User */
    showButtonAddGroup = rightsUserUtil.isAuthorizedUser();
  } else {
    showButtonAddGroup = rightsUserUtil.hasRightsToUpdateGroup(groupId);
  }
  const [showAddGroup, setShowAddGroup] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  let handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const menuButtonAdd = [];

  if (showButtonAddGroup) {
    menuButtonAdd.push({
      key: 'group.add',
      text: polyglot.t('freshwatch.store.add'),
      onClick: () => setShowAddGroup(true),
    });
  }

  if (menuButtonAdd.length === 0) {
    return null;
  }

  if (menuButtonAdd.length === 1) {
    handleClick = menuButtonAdd[0].onClick;
  }

  return (
    <>
      {showButtonAddGroup && (
        <AddStoreModal
          showModal={showAddGroup}
          closeModal={() => setShowAddGroup(false)}
        />
      )}

      <IconButton
        onClick={handleClick}
        aria-controls={open ? 'actions-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
      >
        <AddIcon />
      </IconButton>

      <MenuPrimary
        anchorEl={anchorEl}
        id="actions-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
      >
        {menuButtonAdd.map((item) => (
          <MenuItemPrimary key={item.key} onClick={item.onClick}>
            {item.text}
          </MenuItemPrimary>
        ))}
      </MenuPrimary>
    </>
  );
}

export default AddButtonStoreManager;
